<template>
  <div>
    <loader v-if="loading"></loader>

    <section class="pt-5 mt-5 bg-grey">
      <div class="container">

        <div class="main-heading pb-4">
          <h1 class="title-section">Folders</h1>
        </div>

        <div class="gride-container" v-if="folders.length">
            <div class="gride-box folder-card"
                v-for="folder in folders"
                :key="folder.folder_id">

                <router-link
                    :to="{ name: 'GalleryImages', params: { folderID: folder.folder_id } }"
                    class="folder-link">

                    <!-- Cover -->
                    <div class="folder-cover">
                    <img
                        :src="folder.cover_image"
                        @error="$event.target.src='assets/images/placeholder.png'"
                    />
                    </div>

                    <!-- Details -->
                    <div class="folder-info">
                        <h6 class="folder-title">{{ folder.folder_name }}</h6>

                        <div class="folder-meta">
                            <span><b>Event Name</b> <br/>{{ folder.event_name }}</span>
                           
                            <span><b>Venue Name</b> <br/>{{ folder.venue_name }}</span>
                        </div>

                        <div class="folder-date">
                            
                            {{ formatDate(folder.event_date) }}
                        </div>
                    </div>


                </router-link>
            </div>
                <div class="text-center mt-4" v-if="current_page < total_pages">
                    <button class="btn btn-primary" @click="loadMore">
                        Load More Folders
                    </button>
                </div>
        </div>

        <div class="nodata" v-else>
          <h1>No Folders Found</h1>
        </div>
        
      </div>
    </section>
  </div>
  
</template>
<style>
.folder-card {
  background: linear-gradient(180deg, #1a1a1a, #141414);
  border-radius: 14px;
  overflow: hidden;
  width: 260px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.folder-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
}

/* Image */
.folder-cover {
  height: 200px;
}

.folder-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Info */
.folder-info {
  padding: 14px 16px 18px;
  text-align: left;
}

.folder-title {
  color: #ffffff;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}

/* Meta row */
.folder-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #9a9a9a;
  margin-bottom: 8px;
}

.folder-meta .dot {
  font-size: 10px;
  opacity: 0.6;
}

/* Date */
.folder-date {
  font-size: 12px;
  color: #ff2a2a;
  font-weight: 500;
}

</style>
<script>
import { HTTP } from '../../_helper/http-constants.js';

export default {
name: "GalleryFolders",
data() {
    return {
        albumID: this.$route.params.albumID,
        folders: [],
        loading: false,
        current_page: 1,
        total_pages: 1,
        limit: 50
    }
},

  methods: {
  formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  },

    fetchFolders() {
            this.loading = true;
            HTTP.get(`/gallery/albums/${this.albumID}/folders?page=${this.current_page}&limit=${this.limit}`)
            .then(res => {
                if (res.data.status === 200) {

                if (this.current_page === 1) {
                    this.folders = res.data.data;
                } else {
                    this.folders = [...this.folders, ...res.data.data];
                }

                this.total_pages = res.data.total_pages;
                }
                this.loading = false;
            })
            .catch(() => this.loading = false);
        },

        loadMore() {
            if (this.current_page < this.total_pages) {
            this.current_page++;
            this.fetchFolders();
            }
        }
    },
  mounted() {
    console.log("Album ID:", this.albumID); // DEBUG

    this.loading = true;
    HTTP.get(`/gallery/albums/${this.albumID}/folders`)
      .then(res => {
        if (res.data.status === 200) {
          this.folders = res.data.data;
        }
        this.loading = false;
      })
      .catch(() => this.loading = false);
  }
}
</script>
